import { addListener, getNextSibling } from "@grindex-common/helpers/domManipulation";

function init() {
	document.addEventListener("DOMContentLoaded", initTables);
	const CLASS_SEARCH_CONTAINER = "table--search--container";
	function initTables() {
		const $sortableTables = document.querySelectorAll(".table-sortable");
		const $searchableTables = document.querySelectorAll(".table-searchable");

		$searchableTables.forEach(($searchableTable) => {
			const $searchContainer = document.createElement("div");
			const $searchInput = document.createElement("input");

			$searchInput.type = "text";
			$searchContainer.classList.add(CLASS_SEARCH_CONTAINER);
			$searchInput.classList.add("table--search--input");

			$searchContainer.appendChild($searchInput);

			$searchableTable.parentElement.insertBefore($searchContainer, $searchableTable);

			addListener($searchInput, "keyup", searchTable);
		});

		$sortableTables.forEach(($table) => {
			const $headers = $table.querySelectorAll("th");
			$headers.forEach(($header) => {
				addListener($header, "click", sortOn);
			});
		});

		function searchTable(evt) {
			const $searchField = evt.target;
			const $table = getNextSibling($searchField.closest(`.${CLASS_SEARCH_CONTAINER}`));
			const searchQuery = $searchField.value.toUpperCase();
			const $cells = $table.querySelectorAll("td");

			$searchField.style.background = "none";

			$cells.forEach(($cell) => {
				const cellValue = $cell.textContent || $cell.innerText;
				if (searchQuery.length < 1) {
					$cell.dataset.searchResult = "false";
				} else if (cellValue.toUpperCase().indexOf(searchQuery) > -1) {
					$cell.dataset.searchResult = "true";
				} else {
					$cell.dataset.searchResult = "false";
				}

				// Needed to force IE to update the visuals of the cell
				$cell.innerText = cellValue;
			});
		}

		function sortOn(evt) {
			const $th = evt.target;
			const $table = $th.closest("table");
			const $tbody = $table.querySelector("tbody");
			const $rows = $tbody.querySelectorAll("tr");
			const $headers = $table.querySelectorAll("th");

			const reverse = $th.dataset.reverse === "true" ? true : false;
			const columnIndex = $th.cellIndex;

			$headers.forEach(($header) => {
				$header.dataset.sortedOn = "false";
				$header.dataset.reverse = reverse ? "false" : "true";
			});

			$th.dataset.sortedOn = "true";

			const tableData = [];

			var trClasses = $rows[1].className;
			var tdClasses = $tbody.querySelector("td").className;

			function createRow() {
				const $row = document.createElement("tr");
				$row.className = trClasses;
				return $row;
			}

			function createCell(cellValue) {
				const $cell = document.createElement("td");
				$cell.className = tdClasses;
				$cell.innerHTML = cellValue;

				return $cell;
			}

			$rows.forEach(($row) => {
				const rowData = [];

				$row.querySelectorAll("td").forEach(($cell) => {
					rowData.push($cell.innerHTML);
				});

				tableData.push(rowData);
			});

			const sorted = tableData.sort(function (a, b) {
				return reverse ? (a[columnIndex] < b[columnIndex] ? 1 : -1) : a[columnIndex] > b[columnIndex] ? 1 : -1;
			});

			$tbody.innerHTML = "";

			sorted.forEach((row) => {
				const $row = createRow();

				row.forEach((cellValue) => {
					const $cell = createCell(cellValue);
					$row.appendChild($cell);
				});

				$tbody.append($row);
			});
		}
	}
}

export { init };
